<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="站点统计代码管理">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con show">
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-model="condition.site_id"  clearable></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">统计代码</span>
                            <div class="input-condition">
                                <el-input v-model="condition.content" placeholder="输入统计代码模糊查询" clearable></el-input>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">启用状态</span>
                            <div class="input-condition">
                                <el-select v-model="condition.status" filterable placeholder="请选择">
                                    <el-option
                                    v-for="item in statusList"
                                    :key="item.id"
                                    :label="item.value"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                    </div>
                </div>
                <el-table
                    :data="list"
                    style="width: 100%"
                    :highlight-current-row="true"
                    :border="true"
                    tooltip-effect="dark"
                    ref="multipleTable"
                    v-loading="isLoading"
                    header-cell-class-name="table-back"
                    class="list-table"
                >
                    <el-table-column  label="ID" prop="id" width="80px" align="center"></el-table-column>
                    <el-table-column  label="站点" prop="name"  width="100px" align="center"></el-table-column>
                    <el-table-column  label="统计代码" prop="content" align="center">
                        <template slot-scope="scope">
                            <el-tooltip popper-class="tooltip" effect="dark" :content="scope.row.content" placement="top">
                                <span class="ellipse3">{{scope.row.content}}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column  label="启用状态" prop="status" width="100px" align="center">
                        <template slot-scope="scope">
                            <el-switch active-color="#13ce66"
                                :disabled="!scope.row.content"
                                v-model="scope.row.status"
                                :active-value='1'
                                :inactive-value='0'
                                @change="status => change(status,
                                scope.row)" ></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column  label="更新人" prop="operator" width="100px" align="center"></el-table-column>
                    <el-table-column  label="更新时间" prop="updated_at" width="180px" align="center"></el-table-column>
                    <el-table-column label="操作" width="200px" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="openEdit(scope.$index, scope.row)" v-permission="'business.sites.statistical.edit'">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <template v-if="list.length > 0">
                    <!-- :total="list.length" -->
                    <el-pagination background layout="total,prev, pager, next"  :current-page="condition.page" :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                </template>
                <edit-statistics ref="editStatisticsRef" :callback="initData" />
            </el-tab-pane>
        </el-tabs>   
    </div>
</template>
<script>
import editStatistics from "./statisticsComponent/editStatistics"
import {getStatisCodes,editStatisCodeStatus } from "@/service/site"
import SiteAutoComplete from "../../../components/auto-complete/site-auto-complete";

export default {
    name: 'SiteList',
    components: {
        SiteAutoComplete,
        editStatistics
    },
    data() {
        return {
            condition: {
                site_id: '',
                content: '',
                status: '',
                total : 0,
                per_page : 10,
                page : 1,
            },
            isLoading: false, // 是否显示loading加载
            list: [],
            host:"",
            statusList:[{
                id:"",
                value:"全部"
            },{
                id:1,
                value:"开启"
            },{
                id:0,
                value:"关闭"
            }]
        }
    },
    mounted () {
        this.initData()
        const domain=document.domain
        this.host = window.serverConfig[window.siteMap[domain]].VUE_APP_HOST.substring(14)
    },
    methods: {
        /** 初始化数据请求 */
        async initData () {
            let query = this.condition
            this.isLoading = true
            await getStatisCodes(query).then((data) => {
                let listData = data.data
                this.condition.total = data.total
                this.list = listData
            })
            this.isLoading = false
        },
        openEdit(index, row) {
            this.$refs.editStatisticsRef && this.$refs.editStatisticsRef.openMenu(row)
        },
        /** 监听到改变switch */
        change (status, data) {
            editStatisCodeStatus(data.id, {status}).then((data) => {
            }).catch(err => {
            })
        },

        handleSearch() {
            this.condition.page = 1
            this.initData()
        },
        resetSearch() {
            this.condition = {
                site_id: '',
                content: '',
                status: '',
                total : 0,
                per_page : 10,
                page : 1,
            }
            this.initData()
        },
        currentChange (index) {
            this.condition.page = index
            this.initData()
        },
    }
}
</script>
<style>
    .tooltip{
        max-width: 800px;
    }
</style>
<style scoped>
.ellipse3 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}
</style>
